import React, { Component } from "react";
import { batch, connect } from "react-redux";
import PropTypes from "prop-types";
import TextBlockList from "./TextBlockList";
import TextBasicList from "./TextBasicList";
import TextMyFontsList from "./TextMyFontsList";
import axios from "axios";
import {
  closeSlider,
  resetPage,
  switchMediaTab,
} from "../../../../_actions/sidebarSliderActions";
import {
  FONTS_COMBINATION_PANEL,
  FONTS_SLIDER_PANEL,
  TEXT_SLIDER_PANEL,
} from "../../constants";
import { Box, TabList, TabPanels, Tab, TabPanel, Tabs } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

class TextSliderPanel extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      selectedTab: props.sidebarSlider.sliderPanelType
        ? props.sidebarSlider.sliderPanelType
        : TEXT_SLIDER_PANEL,
      showMoreFontBrowser: false,
    };
  }

  componentDidMount() {
    // Do nothing
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  onTabChanged = (selectedIndex) => {
    let panelType = TEXT_SLIDER_PANEL;

    switch (selectedIndex) {
      case 0:
        panelType = TEXT_SLIDER_PANEL;
        break;

      case 1:
        panelType = FONTS_SLIDER_PANEL;
        break;

      case 2:
        panelType = FONTS_COMBINATION_PANEL;
        break;
      default:
        panelType = TEXT_SLIDER_PANEL;
    }
    this.onSelectTabChange(panelType);
  };

  render() {
    const { canvasRef, t } = this.props;

    return (
      <>
        <Box id="text-tab" d={"flex"} flexDirection={"column"} flexGrow={1}>
          <Tabs
            defaultIndex={0}
            onChange={this.onTabChanged}
            variant={"panel"}
            isFitted
            isLazy
          >
            <TabList w={`calc(100% - 16px)`}>               {/* {removed padding right of main panel container for scroller UI, so reducing width} */}
              <Tab>{t("text")}</Tab>
              <Tab>{t("fonts")}</Tab>
              <Tab>{t("variantions")}</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <TextBasicList handler={this.props.artBoardHandler?.handler} />
              </TabPanel>
              <TabPanel>
                <TextMyFontsList canvasRef={canvasRef} />
              </TabPanel>
              <TabPanel>
                <TextBlockList />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </>
    );
  }

  onSelectTabChange = (k) => {
    const { selectedTab } = this.state;

    if (k !== selectedTab) {
      batch(() => {
        this.props.resetPage(this.props.sidebarSlider.searchText);
        this.props.switchMediaTab(k);
      });
    }
    this.setState({ selectedTab: k });
  };
}

TextSliderPanel.propTypes = {
  sidebarSlider: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  sidebarSlider: state.sidebarSlider,
});

const mapDispatchToProps = (dispatch) => ({
  resetPage: (payload) => dispatch(resetPage(payload)),
  switchMediaTab: (sliderPanelType) =>
    dispatch(switchMediaTab(sliderPanelType)),
  closeSlider: () => dispatch(closeSlider()),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(TextSliderPanel)
);
